import gql from "graphql-tag";

export const deleteEmployeeMutation = gql`
  mutation deleteEmployee($userId: ID!) {
    deleteEmployee(userId: $userId) {
      id
    }
  }
`;
